(function () {
  var CHROME =
    "#prod-rating, #see-similar, #storeTagWrapper, #gold-lowest-price, #pdp-key-features, #pdp-key-features__close, #pdp-key-features__open, .slider-buttons, .slider-button, .product-heart, manage-wishlist, share-button, .onnme_badge, .cta_col";

  function isChrome(el) {
    return !!(el && el.closest && el.closest(CHROME));
  }

  function initGallery(root) {
    if (root.dataset.gallerySwipeInit) return;
    if (root.closest("product-modal")) return;
    var container = root.querySelector('[id^="Slider-Gallery-"]');
    if (!container) return;

    var slides = Array.prototype.filter.call(container.children, function (el) {
      return el.id && el.id.indexOf("Slide-") === 0;
    });
    if (!slides.length) return;

    root.dataset.gallerySwipeInit = "true";

    var originalClassName = container.className;
    var track = null;
    var bound = false;
    var didSwipe = false;
    var mql = window.matchMedia("(max-width: 749px)");

    var currentPageEl = root.querySelector(".slider-counter--current");
    var totalPageEl = root.querySelector(".slider-counter--total");
    var prevBtn = root.querySelector('button[name="previous"]');
    var nextBtn = root.querySelector('button[name="next"]');
    if (totalPageEl) totalPageEl.textContent = slides.length;

    var state = {
      index: 0,
      step: 0,
      dragging: false,
      axis: null,
      startX: 0,
      startY: 0,
      startTranslate: 0,
      currentTranslate: 0,
    };

    function updateChrome(index) {
      if (currentPageEl) currentPageEl.textContent = index + 1;
      if (prevBtn) {
        if (index === 0) prevBtn.setAttribute("disabled", "disabled");
        else prevBtn.removeAttribute("disabled");
      }
      if (nextBtn) {
        if (index === slides.length - 1) nextBtn.setAttribute("disabled", "disabled");
        else nextBtn.removeAttribute("disabled");
      }
    }

    function notifyChange(index) {
      root.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: { currentPage: index + 1, currentElement: slides[index] },
        }),
      );
      container.dispatchEvent(new Event("scroll"));
    }

    function applyWidths() {
      var targetWidth = container.clientWidth;
      slides.forEach(function (slide) {
        slide.style.setProperty("width", targetWidth + "px", "important");
      });
      state.step = targetWidth;
    }

    function goTo(index, animate, silent) {
      var max = slides.length - 1;
      index = Math.max(0, Math.min(max, index));
      var changed = index !== state.index;
      state.index = index;
      state.currentTranslate = -index * state.step;
      if (track) {
        track.style.transition =
          animate === false ? "none" : "transform 280ms cubic-bezier(0.22,0.61,0.36,1)";
        track.style.transform = "translate3d(" + state.currentTranslate + "px,0,0)";
      }
      updateChrome(index);
      if (silent) return;
      if (changed) notifyChange(index);
    }

    function onTouchStart(e) {
      if (isChrome(e.target) || !track) return;
      didSwipe = false;
      state.dragging = true;
      state.axis = null;
      state.startX = e.touches[0].clientX;
      state.startY = e.touches[0].clientY;
      state.startTranslate = state.currentTranslate;
      track.style.transition = "none";
    }

    function onTouchMove(e) {
      if (!state.dragging) return;
      var dx = e.touches[0].clientX - state.startX;
      var dy = e.touches[0].clientY - state.startY;
      if (state.axis === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        state.axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      }
      if (state.axis === "y") return;
      e.preventDefault();
      var next = state.startTranslate + dx;
      var min = -(slides.length - 1) * state.step;
      var max = 0;
      if (next > max) next = max + (next - max) * 0.3;
      if (next < min) next = min + (next - min) * 0.3;
      state.currentTranslate = next;
      track.style.transform = "translate3d(" + next + "px,0,0)";
    }

    function onClick(e) {
      if (isChrome(e.target)) return;
      if (didSwipe) {
        didSwipe = false;
        return;
      }
      var slide = slides[state.index] || slides[0];
      var btn = slide && slide.querySelector(".product__media-toggle");
      if (btn) btn.click();
    }

    function onTouchEnd() {
      if (!state.dragging) return;
      state.dragging = false;
      var axis = state.axis;
      state.axis = null;
      if (axis !== "x") return;
      didSwipe = true;
      var dx = state.currentTranslate - state.startTranslate;
      var threshold = state.step * 0.18;
      if (dx <= -threshold) goTo(state.index + 1);
      else if (dx >= threshold) goTo(state.index - 1);
      else goTo(state.index);
    }

    function bindRoot() {
      if (bound) return;
      root.addEventListener("touchstart", onTouchStart, { passive: true });
      root.addEventListener("touchmove", onTouchMove, { passive: false });
      root.addEventListener("touchend", onTouchEnd);
      root.addEventListener("touchcancel", onTouchEnd);
      root.addEventListener("click", onClick);
      bound = true;
    }

    function unbindRoot() {
      if (!bound) return;
      root.removeEventListener("touchstart", onTouchStart);
      root.removeEventListener("touchmove", onTouchMove);
      root.removeEventListener("touchend", onTouchEnd);
      root.removeEventListener("touchcancel", onTouchEnd);
      root.removeEventListener("click", onClick);
      bound = false;
    }

    function activate() {
      bindRoot();
      if (slides.length < 2) return;
      if (track) {
        applyWidths();
        goTo(state.index, false, true);
        return;
      }
      container.classList.add("gallery-swipe-active");
      track = document.createElement("div");
      track.className = "gallery-swipe-track";
      container.appendChild(track);
      slides.forEach(function (slide) {
        slide.style.setProperty("max-width", "none", "important");
        slide.style.setProperty("flex", "none", "important");
        slide.style.setProperty("margin", "0", "important");
        track.appendChild(slide);
      });
      applyWidths();
      goTo(state.index, false, true);
    }

    function deactivate() {
      unbindRoot();
      if (!track) return;
      slides.forEach(function (slide) {
        slide.style.removeProperty("width");
        slide.style.removeProperty("max-width");
        slide.style.removeProperty("flex");
        slide.style.removeProperty("margin");
        container.appendChild(slide);
      });
      track.remove();
      track = null;
      container.className = originalClassName;
    }

    function sync() {
      if (mql.matches) activate();
      else deactivate();
    }

    new ResizeObserver(function () {
      if (track) {
        applyWidths();
        goTo(state.index, false, true);
      }
    }).observe(container);

    mql.addEventListener("change", sync);
    sync();

    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        goTo(state.index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        goTo(state.index + 1);
      });
    }

    root.resetPages = function () {
      var newSlides = Array.prototype.slice.call(
        container.querySelectorAll('[id^="Slide-"]'),
      );
      slides.length = 0;
      Array.prototype.push.apply(slides, newSlides);
      if (totalPageEl) totalPageEl.textContent = slides.length;
      if (track) goTo(0, false);
    };
  }

  function scan() {
    document.querySelectorAll("slider-component[data-gallery-swipe]").forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  document.addEventListener("shopify:section:load", scan);
})();
